import { useState } from "react";
import "./OptionsMenu.scss";
import { Popover } from "@mui/material";

/**
 * Simple menu with predefined options
 * @param {Array} options - Array of option objects.
 * @param {string} options[].label - Text label for the option.
 * @param {string} options[].icon - Optional icon name for the option.
 * @param {Function} options[].callback - Function to execute on interaction.
 * @param {React.ReactNode} children - Content to be rendered inside the menu trigger.
 */

export const OptionsMenu = ({ options, children }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;


  return (<>
    <div className="options-menu-component trigger" onClick={handleClick}>
      {children}
    </div>
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          style: {
            borderRadius: "12px",
            boxShadow: "var(--pop-over-shadow)",
          },
        },
      }}
    >
      <div className="options-menu-component menu-options">
        {options.map((option) => (
          <div
            key={option.label}
            className="option"
            onClick={() => option.callback?.()}
          >
            {option.icon && <i className={option.icon}></i>}
            <span>{option.label}</span>
          </div>
        ))}
      </div>
    </Popover>
  </>
  );
};
